import React, { useState, useRef } from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

import RoadMap from './RoadMap/RoadMap';

import classes from './PharmuniRoadMap.module.scss';


const PharmuniRoadMap = ({position}) => {
    const [value, setValue] = React.useState('1');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    return (
        <div className='container'>
            <div className={classes.wrapper}>
                <h2>Need a Clear Route to Pharma Success?</h2>
                <Box sx={{ width: '100%', typography: 'body1' }}>
                    <TabContext value={value}>
                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                            <TabList
                                className={classes['tab-list']}
                                onChange={handleChange}
                                aria-label="lab API tabs example"
                                centered
                                sx={{
                                    borderBottom: 'none',
                                    '.MuiTabs-indicator': { display: 'none' }
                                }}
                            >
                                <Tab
                                    label="Students"
                                    value="1"
                                    className={value === '1' ? classes['selected-tab-student'] : ''}
                                />
                                <Tab
                                    label="Job Seekers"
                                    value="2"
                                    className={value === '2' ? classes['selected-tab-job-seeker'] : ''}
                                />
                                <Tab
                                    label="Professionals"
                                    value="3"
                                    className={value === '3' ? classes['selected-tab-professional'] : ''}
                                />
                            </TabList>
                        </Box>
                        <TabPanel value="1">
                            <RoadMap type="students" position={position} />
                        </TabPanel>
                        <TabPanel value="2">
                            <RoadMap type="job_seekers" position={position} />
                        </TabPanel>
                        <TabPanel value="3">
                            <RoadMap type="professionals" position={position} />
                        </TabPanel>
                    </TabContext>
                </Box>
            </div>

        </div>
    );
};

export default PharmuniRoadMap;